import React from "react";
import { Route, Routes } from "react-router-dom";
import Homepage from "../Pages/HomePage";
import AboutPage from "../Pages/AboutPage";
import ContactUs from "../Pages/ContactUs";
import OnService from "../Pages/Products/OnService";
import Cubix from "../Pages/Products/Cubix";
import Active from "../Pages/Products/Active";
import Trackline from "../Pages/Products/Trackline";
import Aristi from "../Pages/Products/Aristi";
import CallToAction from "../Pages/CallToActionPage";
import Industry from "../Pages/IndustryPages";
import Manufacturing from "../Pages/IndustryPages/Manufacturing";
import Government from "../Pages/IndustryPages/Government";
import Automobile from "../Pages/IndustryPages/Automobile";
import Chemical from "../Pages/IndustryPages/Chemical";
import FoodAndBeverages from "../Pages/IndustryPages/FoodAndBeverages";
import HealthCare from "../Pages/IndustryPages/HealthCare";
import Pharmaceutical from "../Pages/IndustryPages/Pharmaceutical";
import TransportAndLogistics from "../Pages/IndustryPages/TransportAndLogistics";
import CustomSoftwareDevelopment from "../Pages/ServicePages/CustomSoftwareDevelopment";
import ERPIntegration from "../Pages/ServicePages/ERPIntegration";
import BiometricAndFacialRecognition from "../Pages/ServicePages/BiometricAndFacialRecognition";
import ProjectBasedOutsourcing from "../Pages/ServicePages/ProjectBasedOutsourcing";
import RFIDAndBarcodeSolutions from "../Pages/ServicePages/RFIDAndBarcodeSolutions";
import MachineVisionSolutions from "../Pages/ServicePages/MachineVisionSolutions";
import ProductLinePrinting from "../Pages/ServicePages/ProductLinePrinting";
import IdentityManagementSolutions from "../Pages/ServicePages/IdentityManagementSolutions";
import PageNotFound from "../Pages/PageNotFound";

const Routing = () => {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<Homepage />} />
        <Route path="/about" exact element={<AboutPage />} />
        <Route path="/contact-us" exact element={<ContactUs />} />
        <Route path="/connect-with-us" exact element={<CallToAction />} />

        {/* Products route */}
        <Route path="/products/on-service" exact element={<OnService />} />
        <Route path="/products/cubix" exact element={<Cubix />} />
        <Route path="/products/active" exact element={<Active />} />
        <Route path="/products/trackline" exact element={<Trackline />} />
        <Route path="/products/aristi" exact element={<Aristi />} />

        {/* Industry route */}
        <Route path="/industry" exact element={<Industry />} />
        <Route
          path="/industry/manufacturing"
          exact
          element={<Manufacturing />}
        />
        <Route path="/industry/government" exact element={<Government />} />
        <Route path="/industry/automobile" exact element={<Automobile />} />
        <Route path="/industry/chemical" exact element={<Chemical />} />
        <Route
          path="/industry/food-and-beverages"
          exact
          element={<FoodAndBeverages />}
        />
        <Route path="/industry/health-care" exact element={<HealthCare />} />
        <Route
          path="/industry/pharmaceutical"
          exact
          element={<Pharmaceutical />}
        />
        <Route
          path="/industry/transport-and-logistic"
          exact
          element={<TransportAndLogistics />}
        />

        {/* Service route */}
        <Route
          path="/service/custom-software-development"
          exact
          element={<CustomSoftwareDevelopment />}
        />
        <Route
          path="/service/erp-integration"
          exact
          element={<ERPIntegration />}
        />
        <Route
          path="/service/biometric-and-facial-recognition"
          exact
          element={<BiometricAndFacialRecognition />}
        />
        <Route
          path="/service/project-based-outsourcing"
          exact
          element={<ProjectBasedOutsourcing />}
        />
        <Route
          path="/service/rfid-and-barcode-solutions"
          exact
          element={<RFIDAndBarcodeSolutions />}
        />
        <Route
          path="/service/machine-vision-solutions"
          exact
          element={<MachineVisionSolutions />}
        />
        <Route
          path="/service/product-line-printing"
          exact
          element={<ProductLinePrinting />}
        />
        <Route
          path="/service/identity-management-solution"
          exact
          element={<IdentityManagementSolutions />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default Routing;
